import Vue from "vue";
import VueRouter from "vue-router";
import Login from "../views/Login";
import Main from "../views/Main";

import UsersAdmin from "../views/pages/UsersAdmin";
import DocumentsList from "../views/pages/DocumentsList";
import PlaceSchool from "../views/pages/PlaceSchool";
import FacultySpec from "../views/pages/FacultySpec";
import StatementEdit from "../views/pages/StatementEdit";
import ApplicantsList from "../views/pages/ApplicantsList";
import Plan from "../views/pages/Plan";
import pError from "../views/pages/p404";
import Temp from "../views/pages/Temp";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Login",
    component: Login,
  },
  {
    path: "/main",
    name: "Main",
    component: Main,
    children: [
      {
        path: "/placeSchool",
        name: "PlaceSchool",
        component: PlaceSchool,
      },
      {
        path: "/facultySpec",
        name: "FacultySpec",
        component: FacultySpec,
      },
      {
        path: "/plan",
        name: "Plan",
        component: Plan,
      },
      {
        path: "/",
        name: "ApplicantsList",
        component: ApplicantsList,
      },
      {
        path: "/documentsList",
        name: "DocumentsList",
        component: DocumentsList,
      },
      {
        path: "/statementEdit",
        name: "StatementEdit",
        component: StatementEdit,
      },
      {
        path: "/usersAdmin",
        name: "UsersAdmin",
        component: UsersAdmin,
      },
      {
        path: "/temp",
        name: "Temp",
        component: Temp,
      },
    ],
  },
  {
    path: "*",
    name: "p404",
    component: pError,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.name !== "Login" && !localStorage.getItem("user"))
    next({ name: "Login" });
  else next();
});

export default router;
